import React from "react";
import { FormattedMessage } from "react-intl";
import { withRouter } from "react-router-dom";
import { useSelector } from "react-redux";
import { Row, Space, Card } from "@masterteam/mt-design-react";
import findArrowIcon from "../ArrowIcon";
import KPIUpdateIndicator from "../KPIUpdateIndicator";
import useIsAr from "../../Hooks/useIsAr";
import { ReactComponent as DetailsIcon } from "../../assets/images/more-details.svg";
import { ReactComponent as DiscussionIcon } from "../../assets/images/Discussion.svg";
import { ReactComponent as StatusIcon } from "../../assets/images/status-icon.svg";

import { getKPITypeStatusColor } from "../../helpers";
import MeasuresChart from "../MeasuresChart";
import "./style.scss";

function KpiListItem({ data, onClickChat, history, kpiTypes }) {
  const [isAr] = useIsAr();
  const frequencies = useSelector(({ theme }) => theme.Frequencies.item.Items);
  const isPercent = data.UnitOfMeasure === "Percentage";
  const unitOfMeasure = isPercent
    ? "%"
    : isAr
    ? data.ArabicUnitDetails
    : data.EnglishUnitDetails;

  const type = kpiTypes.find((t) => t.KPITypeID === data.KPITypeID);
  const frequency = frequencies.find(
    (t) => t.Value.toLowerCase() === data?.Frequency?.toLowerCase()
  );
  const statuses = type?.Status;
  const statusColor = getKPITypeStatusColor(statuses, data.Status);

  return (
    <Card
      key={`kpi_${data.ID}`}
      className="kpi-item"
      style={{
        borderColor: statusColor,
      }}
    >
      <Row justify="between" align="center" className="kpi-item_header">
        <div className="kpi-item_header_title">
          {isAr ? data.ArabicName : data.EnglishName}
        </div>
        <KPIUpdateIndicator item={data} iconOnly />
      </Row>
      <Space direction="vertical" size="medium" className="kpi-item_body">
        <Row
          justify="between"
          align="center"
          size="small"
          className="kpi-item_body_details"
        >
          <div>
            <div className="kpi-details-label">
              <FormattedMessage id="measures-table.target" />
            </div>
            {data?.HasNoTarget || data?.HasNoBaseline ? (
              <div className="kpi-details-value">NA</div>
            ) : (
              <div className="kpi-details-value">
                {data?.Target}
                {data.MaxTarget ? " - " : " "}
                {data.MaxTarget}&nbsp;
                {unitOfMeasure}
              </div>
            )}
          </div>
          <div>
            <div className="kpi-details-label">
              <FormattedMessage id="kpi-info.kpi-beseline" />
            </div>
            {data?.HasNoTarget || data?.HasNoBaseline ? (
              <div className="kpi-details-value">NA</div>
            ) : (
              <div className="kpi-details-value">
                {data?.Baseline || ""}&nbsp;{unitOfMeasure}
              </div>
            )}
          </div>
          {/* <div>
            <div className="kpi-details-label">
              <FormattedMessage id="kpi-info.kpi-frequency" />
            </div>
            <div className="kpi-details-value">
              {isAr ? frequency?.Arabic : frequency?.English}
            </div>
          </div> */}
          <Space align="center">
            {/* <div>{findArrowIcon(data.Direction, statuses, data.Status)}</div> */}
            <div
              className="kpi-details-value value"
              style={{
                color: statusColor,
              }}
            >
              {data.Value ? data.Value : "0"}&nbsp;
              {unitOfMeasure}
            </div>
          </Space>
        </Row>
        <div style={{ width: "100%" }} className="meashure-container-list">
          <MeasuresChart
            statuses={statuses}
            kpiFrequency={frequency?.Value}
            data={data.KPIMeasures?.slice(0, 12) || []}
            compact
            HasNoTargetBaseline={data?.HasNoTarget || data?.HasNoBaseline}
          />
        </div>

        <Row size="large" align="center" justify="center">
          <Space align="center">
            <StatusIcon stroke="#55565a" />
            <span>
              <FormattedMessage id="kpi-list.target" />
            </span>
          </Space>
          <Space align="center">
            <StatusIcon stroke="#CECECE" />
            <span>
              <FormattedMessage id="common.actual" />
            </span>
          </Space>
        </Row>
      </Space>
      <Row className="kpi-card-footer">
        <Space
          align="center"
          className={`${data.CanAccess ? "cursor " : " "} d-flex item `}
          onClick={() =>
            data.CanAccess ? history.push(`/splus/kpi-details/${data?.ID}`) : {}
          }
        >
          <DetailsIcon /> <FormattedMessage id="dashboard.moreDetails" />
        </Space>
        <Space
          align="center"
          justify="center"
          className="d-flex item cursor"
          onClick={() => onClickChat()}
        >
          <DiscussionIcon /> <FormattedMessage id="common.discussion" />
        </Space>
      </Row>
    </Card>
  );
}

export default withRouter(KpiListItem);
